<script lang="ts">
  import {Button} from '@components';
  import {toTime} from '@/utils/common';
  import {createEventDispatcher} from 'svelte';
  import ProgressBar from './ProgressBar.svelte';
  import editorStore from '../../lib/editor/editor.store';
  import {animationPlayerStore} from '../animations/AnimationController.svelte';
  import {fly} from 'svelte/transition';
  import {step} from '../../store';
  import {STEP} from '../../types/common';

  export let progressBar: any;
  export let showDuration: boolean = false;
  let playing: boolean = false;
  export let duration: number = 0;
  export let progress: number = 0;
  const dispatch = createEventDispatcher();

  const stopVideo = () => dispatch('stop-video');
  // const playVideo = () => dispatch('play-video');
  const playVideo = () => {
    dispatch('play-video');
    console.log('anim', $animationPlayerStore.playing);
    playing = !playing;
    console.log(playing);
  };
  const pauseVideo = () => dispatch('pause-video');
  const seekTimeline = (e: CustomEvent) => dispatch('seek-timeline', e.detail);
  const adjustSeek = (value: number) => dispatch('adjust-seek', value);
  const clearEditorStore = () => {
    if (!$editorStore.active) return false;
    // editorStore.highlightElement(null);
    editorStore.setActiveComponent(null);
  };

  // $: playable = !$animationPlayerStore.loading;
  // $: playing = !$animationPlayerStore.playing;
  let btnClass = 'bg-primary border-primary';
</script>

<div class="relative">
  <div class="z-20 flex w-full items-center gap-3 border-t border-zinc-300 bg-white p-4">
    <Button
      on:click={() => adjustSeek(-0.05)}
      icon="Rewind"
      iconSize="small"
      className="!rounded-full !text-primary border-2 !py-2 bg-white border-primary  !py-2"
    />
    {#if playing}
      <Button
        on:click={playVideo}
        icon="Pause"
        iconSize="small"
        className="!rounded-full !text-white border-4  !py-2 {btnClass}"
      />
    {:else}
      <Button
        on:click={playVideo}
        icon="Play"
        iconSize="small"
        className="!rounded-full !text-white border-4  !py-2 {btnClass}"
      />
    {/if}
    <Button
      on:click={() => adjustSeek(0.05)}
      icon="Forward"
      iconSize="small"
      className="!rounded-full !text-primary border-2 !py-2 bg-white border-primary  !py-2"
    />
    <ProgressBar bind:this={progressBar} on:progress-change={seekTimeline} />
    {#if showDuration}
      {#if duration > 0}
        <div class="flex font-medium text-zinc-900">
          <span>{toTime(duration * (progress / 100))} / {toTime(duration)}</span>
        </div>
      {:else}
        <div class="flex font-medium text-zinc-700">--:-- / --:--</div>
      {/if}
    {/if}
  </div>
</div>

<style>
  #progressBar {
    height: 30px;
    top: -29px;
    min-width: 90px;
    display: flex;
    font-size: 7pt;
  }
</style>
